/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListNotificationsParams = {
cursor?: string | null;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
unread_only?: boolean;
read_only?: boolean;
archived?: boolean;
};
